import {
  getApiDevosStreak,
  getApiDevosStreakHistory,
  getApiDevosStreakHistoryResponse,
  getApiDevosStreakResponse,
} from "twi-client";
import { Sentry } from "~/lib/sentry";

export interface StreakResponse {
  currentStreak: number;
  lastListenDate: string;
  weekStreak: number;
}

export interface StreakHistoryResponse {
  dates: Array<string>;
}

export const StreakClientService = {
  getStreak: async (): Promise<StreakResponse | null> => {
    try {
      const data = await getApiDevosStreak();
      if (!data) {
        return null;
      }

      const parsedData = getApiDevosStreakResponse.safeParse(data);
      if (!parsedData.success) {
        throw parsedData.error;
      }

      return {
        currentStreak: parsedData.data.currentStreak ?? 0,
        lastListenDate: parsedData.data.lastListenDate ?? "",
        weekStreak: parsedData.data.weekStreak ?? 0,
      };
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          component: "Streak",
          api: "devos/streak",
        },
        extra: { error: error instanceof Error ? error.message : String(error) },
      });
      return null;
    }
  },

  getStreakHistory: async (): Promise<StreakHistoryResponse | null> => {
    try {
      const data = await getApiDevosStreakHistory();
      if (!data) {
        return null;
      }

      const parsedData = getApiDevosStreakHistoryResponse.safeParse(data);
      if (!parsedData.success) {
        throw parsedData.error;
      }

      return {
        dates: parsedData.data.dates ?? [],
      };
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          component: "StreakHistory",
          api: "devos/streak/history",
        },
        extra: { error: error instanceof Error ? error.message : String(error) },
      });
      return null;
    }
  },
};
